import { render } from "./ItemsGrid.vue?vue&type=template&id=e9983372&scoped=true"
import script from "./ItemsGrid.vue?vue&type=script&lang=js"
export * from "./ItemsGrid.vue?vue&type=script&lang=js"

import "./ItemsGrid.vue?vue&type=style&index=0&id=e9983372&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e9983372"

export default script